import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import logo from '../../assets/img/reactlogo.png';

function Login() {
  const [errors, setErrors] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        let deviceid = generateRandomString();
        const response = await axios.post('/user/signin-new', jsonData, { headers: { "Content-Type": "application/json", deviceid } });
        const { status, message, token } = response.data;
        if (status) {
          sessionStorage.removeItem("admin_notice_shown");
          localStorage.setItem("deviceId", deviceid);
          localStorage.setItem("token", token);
          //navigate('/admin/dashboard');
          window.location.href = "/admin/dashboard";
        }
        toast(message);
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };
  function generateRandomString(length = 30) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charsLength = chars.length;

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charsLength);
      result += chars[randomIndex];
    }

    return result;
  }
  function addSpaceBetweenCases(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  };
  const deleteError = (e) => {
    const errorKey = e.target.name;
    if (errorKey) {
      const updatedErrors = { ...errors };
      delete updatedErrors[errorKey];
      setErrors(updatedErrors);
    }
  };
  return (
    <div class="col-lg-6 d-flex align-items-center justify-content-center">
      <div class="auth-form-transparent text-left p-3">
        <div class="brand-logo">
          <img src={logo} alt="logo" />
        </div>
        <h4>Welcome back!</h4>
        <h6 class="font-weight-light">Happy to see you again!</h6>
        <form class="pt-3" onSubmit={handleSubmit}>
          <div class="form-group">
            <label for="exampleInputEmail">Email</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-user text-primary"></i>
                </span>
              </div>
              <input type="text" class="form-control form-control-lg border-left-0" id="exampleInputEmail" name="email" placeholder="Email" onChange={deleteError} requiredField="true" />
            </div>
            <span className="error">{errors && errors?.email}</span>
          </div>
          <div class="form-group">
            <label for="exampleInputPassword">Password</label>
            <div class="input-group">
              <div class="input-group-prepend bg-transparent">
                <span class="input-group-text bg-transparent border-right-0">
                  <i class="ti-lock text-primary"></i>
                </span>
              </div>
              <input type="password" class="form-control form-control-lg border-left-0" id="exampleInputPassword" name="password" placeholder="Password" onChange={deleteError} requiredField="true" />
            </div>
            <span className="error">{errors && errors?.password}</span>
          </div>
          <div className="my-2 text-end text-right">
            <Link to="/forgot-password" className="auth-link text-primary small">
              Forgot password?
            </Link>
          </div>
          {/* <div class="my-2 d-flex justify-content-between align-items-center">
            <div class="form-check">
              <label class="form-check-label text-muted">
                <input type="checkbox" class="form-check-input" />
                Keep me signed in
              </label>
            </div>
          </div> */}
          <div class="my-3">
            <button type="submit" class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">LOGIN</button>
          </div>
          <div class="text-center mt-4 font-weight-light">
            Don't have an account? <Link to="/register" class="text-primary">Create</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
